export enum EDocumentEntityType {
  ORDERS = 'orders',
  REQUESTS = 'requests',
  MULTIREQUESTS = 'multiRequests',
  MY_DOCUMENTS = 'myDocuments',
}
